<template>
  <span class="form_label" :class="{required: innerRequired}">{{ innerRequired ? '必須' : '任意'}}</span>
</template>

<script>
  export default {
    props: {
      required: {
        type: [String, Boolean, Number],
        default: false,
      },
    },
    computed: {
      innerRequired() {
        if (typeof this.required === 'boolean') {
          return this.required
        }

        return String(this.required) === '1'
      }
    }
  }
</script>
